import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

import LoadingSpinner from "./LoadingSpinner/LoadingSpinner";

export default function UnauthorizedRedirect() {
  const location = useLocation();

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (import.meta.env.VITE_APP_ENVIRONMENT !== "local") {
        const url = new URL(import.meta.env.VITE_LOGIN_URL);
        url.searchParams.append("redirect-to", "usmca");
        window.location.href = url.toString();
      }
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, []);

  if (import.meta.env.VITE_APP_ENVIRONMENT === "local") {
    return <Navigate to="/login" state={{ from: location.pathname }} />;
  }
  return <LoadingSpinner />;
}
